import React, { FC } from 'react'

import { InterSvgIcon } from 'components'
import { Page, PageContent } from 'common'

import { TEntityTransactionViewProps } from '../types'
import {
  DetailsTextContaier,
  EntityTransactionViewContainer,
  EntityTransactionViewContentContainer,
  EntityTransactionViewFootnoteContainer,
  FlagContainer,
  FootnoteTextContaier,
  TitleTextContaier,
} from '../styles'

export const EntityTransactionView: FC<TEntityTransactionViewProps> = ({
  icon,
  title,
  details,
  footnote,
}) => (
  <Page>
    <PageContent>
      <EntityTransactionViewContainer>
        <FlagContainer>
          <InterSvgIcon iconRef={icon} width={80} height={80} />
        </FlagContainer>
        <EntityTransactionViewContentContainer>
          <TitleTextContaier>{title}</TitleTextContaier>
          <DetailsTextContaier>{details}</DetailsTextContaier>
        </EntityTransactionViewContentContainer>
        <EntityTransactionViewFootnoteContainer>
          <FootnoteTextContaier>{footnote}</FootnoteTextContaier>
        </EntityTransactionViewFootnoteContainer>
      </EntityTransactionViewContainer>
    </PageContent>
  </Page>
)
